export default __webpack_public_path__ + "img/e115dc5289b8c506aeb3d52f240542d4.svg";